module.exports = __webpack_public_path__ + "static/media/Send-Receive.dca2e549.mp4";